import React from 'react'

export const FORM_LANGS = [
    { code: 'ar', ar: 'العربية', en: 'Arabic' },
    { code: 'en', ar: 'الإنجليزية', en: 'English' },
];

export const langLabel = (code, isAr = true) => {
    const lang = FORM_LANGS.find((item) => item.code === code) || FORM_LANGS[0];
    return isAr ? lang.ar : lang.en;
};

// "العنوان (العربية)" — اسم الحقل مع اللغة اللي بتتكتب.
export const withLangLabel = (label, code, isAr = true) => `${label} (${langLabel(code, isAr)})`;

// زرار تبديل لغة الحقول (نفس فكرة FormLangBar في sales): حقل واحد ظاهر في المرة.
//  - النقطة الخضرا: اللغة دي متعبية.
//  - التاب الأحمر: فيه خطأ في اللغة دي (من `errors` = نتيجة validateBilingual).
//  - تحت الأزرار: قائمة الأخطاء، والضغط على أي خطأ بيفتح اللغة بتاعته.
const LangSwitch = ({ value, onChange, isAr = true, filled = {}, invalid = false, errors = null, messages = [], className = '' }) => {
    const langHasError = (code) => Boolean(errors && Object.keys(errors[code] || {}).length);
    return (
        <div className={`flex flex-col gap-1.5 ${className}`}>
            <div className="flex items-center justify-end gap-1 text-xs" role="tablist">
                {FORM_LANGS.map((lang) => {
                    const active = value === lang.code;
                    const hasValue = Boolean(filled?.[lang.code]);
                    const hasError = langHasError(lang.code);
                    return (
                        <button
                            key={lang.code}
                            type="button"
                            role="tab"
                            aria-selected={active}
                            onClick={() => onChange?.(lang.code)}
                            className={`relative inline-flex items-center gap-1.5 rounded-md px-3 py-1 font-bold transition ${active
                                ? (hasError ? 'bg-red-600 text-white shadow-sm' : 'primary-bg-color text-white shadow-sm')
                                : (hasError ? 'bg-red-50 text-red-700 ring-1 ring-red-300 hover:bg-red-100' : 'bg-emerald-50 text-emerald-700 hover:bg-emerald-100')}`}
                        >
                            {isAr ? lang.ar : lang.en}
                            {hasError ? (
                                <span className={`inline-flex h-3.5 w-3.5 items-center justify-center rounded-full text-[9px] font-black ${active ? 'bg-white text-red-600' : 'bg-red-600 text-white'}`}>!</span>
                            ) : (
                                <span
                                    className={`h-1.5 w-1.5 rounded-full ${hasValue ? 'bg-emerald-400' : invalid ? 'bg-red-500' : active ? 'bg-white/40' : 'bg-emerald-200'}`}
                                    title={hasValue ? (isAr ? 'تمت الكتابة' : 'Filled') : (isAr ? 'فارغ' : 'Empty')}
                                />
                            )}
                        </button>
                    );
                })}
            </div>
            {messages.length > 0 && (
                <div className="rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-xs text-red-700" role="alert">
                    {messages.map((message, index) => (
                        <button
                            key={`${message.lang}-${index}`}
                            type="button"
                            onClick={() => onChange?.(message.lang)}
                            className="flex w-full items-start gap-1.5 py-0.5 text-start font-semibold hover:underline"
                        >
                            <span className="mt-1 h-1.5 w-1.5 shrink-0 rounded-full bg-red-500" />
                            <span>{message.text}</span>
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default LangSwitch
